<template>
  <div id="app">
    <div class="header">
      <van-nav-bar title="" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <van-form @submit="onSubmit" style="margin-top: 10px">
      <span style="line-height: 50px;font-family: '黑体'">
        请选择故障的识别编码：
      </span>
      <van-dropdown-menu style="width: 180px">
        <van-dropdown-item v-model="houseHold" :options="options" />
      </van-dropdown-menu>
      <div class="clear" style="clear: both"></div>
      <van-cell-group inset style="margin-top:30px">
        <van-field
            type="textarea"
            v-model="faultInfo"
            placeholder="请填写具体故障信息"
            :rules="[{ required: true, message: '请填写故障信息哦' }]"
        />
      </van-cell-group>
        <van-button round block type="primary" native-type="submit" @click="onSubmit">
          提交
        </van-button>
    </van-form>
  </div>
</template>

<script>

import {badInfo} from "../common/api/default";
import jump from "../common/jump";

export default {
  name: "default",
  data(){
    return{
      faultInfo:'',
      houseHold:"",
      options : [],
    }
  },
  mounted(){
    let num = Object.keys(this.$route.query).length
    let content = this.$route.query
    for (let i=0;i<num;i++){
      this.options.push({text:content[i].houseHoldNumber,value:content[i].devId})
    }
  },
  methods:{
    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    onSubmit(){
      console.log(this.houseHold)
      badInfo({devId:this.houseHold,faultInfo:this.faultInfo}).then(res => {
        this.$toast.success('提交成功')
        this.houseHold = null
        this.faultInfo = ''
      })
    }
  }
}
</script>

<style scoped>
/deep/ .van-field__control{
  /*border:1px solid #505050 !important;*/
  letter-spacing: 2px;
  padding: 10px;
  height: 120px;
  border-radius: 10px;
  box-shadow: red 0px 0px 15px -5px;
  /*box-shadow: rgba(80,80,80,0.2) 0px 0px 15px -5px;*/

}
.van-button--round{
  width: 90%;
  background-color: #0f72dd;
  margin: 20px auto;
}
.van-popup--top{
  width: 100%;
}
/deep/ .van-dropdown-item__content{
  margin-left:0
}
/deep/ .van-popup--top{
  width: 100%;
}
/deep/ .van-cell__title, .van-cell__value{
  margin-top:20px
}
.van-dropdown-menu{
  float: right;
}
</style>